//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');
//指标配置
const indicatorsAllocation = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/indicators/indicatorsAllocation.vue')),
    'indicatorsAllocation'
  );
//评级标准
const gradeStandard = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/indicators/gradeStandard.vue')),
    'gradeStandard'
  );
//授信评级
const creditRating = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/indicators/creditRating.vue')),
    'creditRating'
  );
//权重配置
const weightAllocation = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/indicators/weightAllocation.vue')),
    'weightAllocation'
  );

const indicators = {
  path: '/indicators',
  name: '/indicators',
  component: index,
  children: [
    {
      path: 'indicatorsAllocation',
      name: 'indicatorsAllocation',
      component: indicatorsAllocation,
      meta: {
        keepAlive: true,
        title: '指标配置',
      },
    },
    {
      path: 'gradeStandard',
      name: 'gradeStandard',
      component: gradeStandard,
      meta: {
        keepAlive: true,
        title: '评级标准',
      },
    },
    {
      path: 'weightAllocation',
      name: 'weightAllocation',
      component: weightAllocation,
      meta: {
        keepAlive: true,
        title: '权重配置',
      },
    },
    {
      path: 'creditRating',
      name: 'creditRating',
      component: creditRating,
      meta: {
        keepAlive: true,
        title: '授信评级',
      },
    },
  ],
};
export default indicators;
